import { render, staticRenderFns } from "./FashionOutfitPreview.vue?vue&type=template&id=2fb75f26&scoped=true&"
import script from "./FashionOutfitPreview.vue?vue&type=script&lang=js&"
export * from "./FashionOutfitPreview.vue?vue&type=script&lang=js&"
import style0 from "./FashionOutfitPreview.vue?vue&type=style&index=0&id=2fb75f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb75f26",
  null
  
)

export default component.exports